import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import axiosInstance from "../utils/axiosInstance";

const SidebarCountsContext = createContext();

export const SidebarCountsProvider = ({ children }) => {
  const [counts, setCounts] = useState({
    supports: 0,
    questions: 0,
    forums: 0,
    polls: 0,
  });

  const fetchCounts = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/stats/pending`,
      );

      if (response.status === 200) {
        const data = await response.data;
        setCounts({
          supports: data.supports,
          questions: data.questions,
          forums: data.forums,
          polls: data.polls,
        });
      }
    } catch (error) {
      console.error("Failed to fetch sidebar counts", error);
    }
  }, []);

  const updateCount = useCallback(() => {
    fetchCounts();
  }, [fetchCounts]);

  useEffect(() => {
    fetchCounts();
  }, [fetchCounts]);

  return (
    <SidebarCountsContext.Provider value={{ counts, updateCount }}>
      {children}
    </SidebarCountsContext.Provider>
  );
};

export const useSidebarCounts = () => useContext(SidebarCountsContext);
